<template>
  <img src="~/assets/icon/icon-danger-triangle.svg" />
</template>
